/* @flow */

import _Footer from './Footer';

export default _Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js